// extracted by mini-css-extract-plugin
export var quantityInput = "_mw-0";